import React from 'react';
import {FaTwitter ,FaInstagram ,FaFacebookF , FaLinkedinIn, FaYoutube} from "react-icons/fa";

const SocialShare = [
    {Social: <FaFacebookF /> , link: 'https://www.facebook.com/share/15SnoHLaBP/?mibextid=wwXIfr'},
    {Social: <FaLinkedinIn /> , link: 'https://www.linkedin.com/in/dennis-isiakpona?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=ios_app'},
    {Social: <FaYoutube />, link: 'https://youtube.com/@dennisogeisiakpona919?si=b3SuwX__wnDRCj1J'},
    {Social: <FaInstagram /> , link: 'https://www.instagram.com/thea.q.u.i.l.a?igsh=MWx4bHlkbThlNXlteg%3D%3D&utm_source=qr'},
    {Social: <FaTwitter /> , link: 'https://x.com/_theaquila_?s=21'}
]

const FooterTwo = () => {
    return (
        <div className="footer-style-2 ptb--30 bg_image bg_image--1" data-black-overlay="6">
            <div className="wrapper plr--50 plr_sm--20">
                <div className="row align-items-center justify-content-between">
                    <div className="col-lg-3 col-md-6 col-sm-6 col-12">
                        <div className="inner">
                            <div className="logo text-center text-sm-left mb_sm--20">
                                <a href="/home-one">
                                    <img src="/assets/images/logo/logo-white.png" height="50rem" alt="Coach DOI"/>
                                </a>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-3 col-md-6 col-sm-6 col-12">
                        <div className="inner text-center">
                            <ul className="social-share rn-lg-size d-flex justify-content-center liststyle">
                                {SocialShare.map((val , i) => (
                                    <li key={i}><a href={`${val.link}`} target="_blank">{val.Social}</a></li>
                                ))}
                            </ul>
                        </div>
                    </div>
                    <div className="col-lg-6 col-md-12 col-sm-12 col-12">
                        <div className="inner text-lg-right text-center mt_md--20 mt_sm--20">
                            <div className="text">
                                <p>Copyright © 2025 Dennis Isiakpona. All rights reserved.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
export default FooterTwo;